import { Pipe, PipeTransform } from '@angular/core';
import { getDomain } from '@laasy/common-layout';

@Pipe({
  name: 'tenantDomainName',
  standalone: true
})
export class TenantDomainNamePipe implements PipeTransform {

  transform(value: string): unknown {
    if(!value) return ''
    if(!(value.includes('https://') || value.includes('http://'))) value = 'https://'+value
    const hostName = getDomain(value);
    return hostName?.replace('www.', '')
  }

}
